import React from 'react';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from './CopyLinkWithText.module.scss';

export const CopyLinkWithText = ({ copyToClipboard }) => {
    return (
        <div className={classes.copyLinkWithTextContainer} onClick={copyToClipboard}>
            <MuiIcon icon={'share'} color={'var(--text-brand-primary)'} />
            <div>Copy Link to clipboard</div>
        </div>
    );
};
